module.exports = __webpack_public_path__ + "static/cloud-sprinkles-115b30865a57ff7380736ceb3a3c766a.gif";